<template>
	<div class="author-div">
		<div :class="isEvenRow == false ? 'customblue' : 'customwhite'">
			<AutoComplete
			    class="auto"
				:multiple="true"
				v-model="row.peopleInvolved"
				:suggestions="filteredPeople"
				field="label"
				@complete="searchAuthors($event)"
				@item-select="selectChanges(row, $event.value)"
				@item-unselect="unselectChanges(row, $event.value)"
			/>
		</div></div
></template>
<script>
import AutoComplete from "primevue/autocomplete/AutoComplete";

export default {
	name: "InputAutoComplete",

	props: {
		row: {},
		isEvenRow: Boolean,
		titlePageAuthors: Array
	},
	components: {
		AutoComplete
	},
	data() {
		return {
			filteredPeople: null
		};
	},
	methods: {
		selectChanges(row, event) {
			this.$emit("autocom", 1, row, event);
		},
		unselectChanges(row, event) {
			this.$emit("autocom", 0, row, event);
		},
		searchAuthors(event) {
			//console.log("titlePageAuthors:"+JSON.stringify(this.titlePageAuthors));
			setTimeout(() => {
				if (!event.query.trim().length) {
					this.filteredPeople = [...this.titlePageAuthors];
				} else {
					this.filteredPeople = this.titlePageAuthors.filter(people => {
						return people.label
							.toLowerCase()
							.startsWith(event.query.toLowerCase());
					});
				}
			}, 250);
		}
	}
};
</script>
<style>
.author-div {
	position: relative;
	width: 100%;
}

.customblue,
.customwhite {
	width: 100%;
}

.p-autocomplete-multiple-container {
	display: flex !important;
	flex-wrap: wrap !important;
	gap: 6px !important;
	padding: 6px 10px !important;
	min-height: 38px !important;
	box-sizing: border-box !important;
	align-items: center !important;
	border: 1px solid #e2e8f0 !important;
	border-radius: 8px !important;
	background: #ffffff !important;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.p-autocomplete-multiple-container:focus-within {
	border-color: #3b82f6 !important;
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15) !important;
}

.p-fluid .p-autocomplete {
	height: 100%;
	width: 100%;
}

.p-input-filled .p-inputtext {
	background-color: white;
}

.customblue .auto .p-autocomplete-multiple-container {
	background-color: #f0f5fa !important;
}

.customblue .auto .p-autocomplete-multiple-container:focus-within {
	background-color: #ffffff !important;
}

.customwhite .auto .p-autocomplete-multiple-container {
	background-color: white !important;
}

/* Selected item tags style - Premium pill style with soft gradient */
.p-autocomplete-token {
	display: inline-flex !important;
	align-items: center !important;
	background: linear-gradient(135deg, #f8fafc, #f1f5f9) !important;
	color: #475569 !important;
	padding: 4px 10px !important;
	border-radius: 9999px !important; /* Pill style */
	font-size: 0.8rem !important;
	font-weight: 600 !important;
	margin: 3px 2px !important;
	box-sizing: border-box !important;
	border: 1px solid #e2e8f0 !important;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.p-autocomplete-token:hover {
	transform: translateY(-1px) scale(1.03) !important;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08) !important;
	border-color: #cbd5e1 !important;
	background: linear-gradient(135deg, #f1f5f9, #e2e8f0) !important;
}

.p-autocomplete-token-label {
	margin-right: 8px !important;
	letter-spacing: 0.01em;
}

.p-autocomplete-token-icon {
	cursor: pointer !important;
	font-size: 0.75rem !important;
	color: #94a3b8 !important;
	transition: all 0.2s ease !important;
	display: inline-flex !important;
	align-items: center;
	justify-content: center;
	width: 14px;
	height: 14px;
	border-radius: 50%;
}

.p-autocomplete-token-icon:hover {
	background-color: #fee2e2 !important;
	color: #ef4444 !important;
	transform: rotate(90deg) !important;
}

/* Typing area style */
.p-autocomplete-input-token {
	display: inline-flex !important;
	flex-grow: 1 !important;
	padding: 0 !important;
	margin: 2px 0 !important;
}

.p-autocomplete-input-token input {
	border: none !important;
	background: transparent !important;
	outline: none !important;
	box-shadow: none !important;
	padding: 2px 0 !important;
	margin: 0 !important;
	font-size: 0.875rem !important;
	color: #1e293b !important;
}

/* Autocomplete suggestions dropdown panel styling */
.p-autocomplete-panel {
	height: auto !important;
	max-height: 250px !important;
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
	border: 1px solid #e2e8f0 !important;
	background-color: #ffffff !important;
	border-radius: 6px !important;
	z-index: 9999 !important;
}

.p-autocomplete-items {
	padding: 4px 0 !important;
	list-style-type: none !important;
	margin: 0 !important;
}

.p-autocomplete-item {
	padding: 8px 12px !important;
	color: #334155 !important;
	font-size: 0.875rem !important;
	cursor: pointer !important;
	transition: background-color 0.15s ease, color 0.15s ease !important;
}

.p-autocomplete-item:hover,
.p-autocomplete-item.p-highlight {
	background-color: #f1f5f9 !important;
	color: #1e293b !important;
}
</style>
